import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

const doUnFollow = async (
  id: number | string,
) => {
  const { data: userData } = await supabase.auth.getSession()

  const { error } = await supabase
    .from('following_users')
    .delete()
    .eq('user_id', id)
    .eq('follow_user_id', userData?.session?.user?.id);

  if (error) {
    throw new Error(error.message)
  }

  return null
}

export default function useRemoveMyFollower(
  id: number | string,
) {
  return useMutation((follow: boolean) => doUnFollow(id), { // eslint-disable-line
    onSuccess: async (res) => res,
  })
}
